/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { Controller, ControllerInterface } from '../Controller'

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    inputs: [],
    name: 'T',
    type: 'error'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'pairId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isStable',
        type: 'bool'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'CreatorRevenueWithdrawn',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8'
      }
    ],
    name: 'Initialized',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'liquidator',
        type: 'address'
      }
    ],
    name: 'LiquidatorUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'OperatorUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'pairId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isStable',
        type: 'bool'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'ProtocolRevenueWithdrawn',
    type: 'event'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'pairGroupId',
            type: 'uint256'
          },
          {
            internalType: 'address',
            name: 'poolOwner',
            type: 'address'
          },
          {
            internalType: 'address',
            name: 'uniswapPool',
            type: 'address'
          },
          {
            internalType: 'bool',
            name: 'isIsolatedMode',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'fee',
            type: 'uint8'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'riskRatio',
                type: 'uint256'
              },
              {
                internalType: 'int24',
                name: 'rangeSize',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'rebalanceThreshold',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.AssetRiskParams',
            name: 'assetRiskParams',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'baseRate',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'kinkRate',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'slope1',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'slope2',
                type: 'uint256'
              }
            ],
            internalType: 'struct InterestRateModel.IRMParams',
            name: 'stableIrmParams',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'baseRate',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'kinkRate',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'slope1',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'slope2',
                type: 'uint256'
              }
            ],
            internalType: 'struct InterestRateModel.IRMParams',
            name: 'underlyingIrmParams',
            type: 'tuple'
          }
        ],
        internalType: 'struct DataType.AddPairParams',
        name: '_addPairParam',
        type: 'tuple'
      }
    ],
    name: 'addPair',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stableAssetAddress',
        type: 'address'
      },
      {
        internalType: 'uint8',
        name: '_marginRounder',
        type: 'uint8'
      }
    ],
    name: 'addPairGroup',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    name: 'allowedUniswapPools',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint64',
        name: '_pairId',
        type: 'uint64'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'tradeAmount',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'tradeAmountSqrt',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'enableCallback',
            type: 'bool'
          },
          {
            internalType: 'bytes',
            name: 'data',
            type: 'bytes'
          }
        ],
        internalType: 'struct TradePerpLogic.TradeParams',
        name: '_tradeParams',
        type: 'tuple'
      },
      {
        internalType: 'uint256',
        name: '_withdrawAmount',
        type: 'uint256'
      }
    ],
    name: 'closeIsolatedPosition',
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: 'int256',
                name: 'perpEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateUnderlying',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateStable',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'perpPayoff',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtPayoff',
                type: 'int256'
              }
            ],
            internalType: 'struct Perp.Payoff',
            name: 'payoff',
            type: 'tuple'
          },
          {
            internalType: 'int256',
            name: 'fee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TradeResult',
        name: 'tradeResult',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256'
      }
    ],
    name: 'getAsset',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'pairGroupId',
            type: 'uint256'
          },
          {
            internalType: 'address',
            name: 'poolOwner',
            type: 'address'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'token',
                type: 'address'
              },
              {
                internalType: 'address',
                name: 'supplyTokenAddress',
                type: 'address'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'totalCompoundDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalBorrowed',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetScaler',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetGrowth',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'debtGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.TokenStatus',
                name: 'tokenStatus',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'baseRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'kinkRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope1',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope2',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct InterestRateModel.IRMParams',
                name: 'irmParams',
                type: 'tuple'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedProtocolRevenue',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedCreatorRevenue',
                type: 'uint256'
              }
            ],
            internalType: 'struct DataType.AssetPoolStatus',
            name: 'stablePool',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'token',
                type: 'address'
              },
              {
                internalType: 'address',
                name: 'supplyTokenAddress',
                type: 'address'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'totalCompoundDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalBorrowed',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetScaler',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetGrowth',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'debtGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.TokenStatus',
                name: 'tokenStatus',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'baseRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'kinkRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope1',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope2',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct InterestRateModel.IRMParams',
                name: 'irmParams',
                type: 'tuple'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedProtocolRevenue',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedCreatorRevenue',
                type: 'uint256'
              }
            ],
            internalType: 'struct DataType.AssetPoolStatus',
            name: 'underlyingPool',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'riskRatio',
                type: 'uint256'
              },
              {
                internalType: 'int24',
                name: 'rangeSize',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'rebalanceThreshold',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.AssetRiskParams',
            name: 'riskParams',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'uniswapPool',
                type: 'address'
              },
              {
                internalType: 'int24',
                name: 'tickLower',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'tickUpper',
                type: 'int24'
              },
              {
                internalType: 'uint64',
                name: 'numRebalance',
                type: 'uint64'
              },
              {
                internalType: 'uint256',
                name: 'totalAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'borrowedAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastRebalanceTotalSquartAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastFee0Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastFee1Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'borrowPremium0Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'borrowPremium1Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'fee0Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'fee1Growth',
                type: 'uint256'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'positionAmount',
                    type: 'int256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'lastFeeGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.UserStatus',
                name: 'rebalancePositionUnderlying',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'positionAmount',
                    type: 'int256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'lastFeeGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.UserStatus',
                name: 'rebalancePositionStable',
                type: 'tuple'
              },
              {
                internalType: 'int256',
                name: 'rebalanceFeeGrowthUnderlying',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'rebalanceFeeGrowthStable',
                type: 'int256'
              }
            ],
            internalType: 'struct Perp.SqrtPerpAssetStatus',
            name: 'sqrtAssetStatus',
            type: 'tuple'
          },
          {
            internalType: 'bool',
            name: 'isMarginZero',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isIsolatedMode',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'feeRatio',
            type: 'uint8'
          },
          {
            internalType: 'uint256',
            name: 'lastUpdateTimestamp',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.PairStatus',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256'
      }
    ],
    name: 'getLatestAssetStatus',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'pairGroupId',
            type: 'uint256'
          },
          {
            internalType: 'address',
            name: 'poolOwner',
            type: 'address'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'token',
                type: 'address'
              },
              {
                internalType: 'address',
                name: 'supplyTokenAddress',
                type: 'address'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'totalCompoundDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalBorrowed',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetScaler',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetGrowth',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'debtGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.TokenStatus',
                name: 'tokenStatus',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'baseRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'kinkRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope1',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope2',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct InterestRateModel.IRMParams',
                name: 'irmParams',
                type: 'tuple'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedProtocolRevenue',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedCreatorRevenue',
                type: 'uint256'
              }
            ],
            internalType: 'struct DataType.AssetPoolStatus',
            name: 'stablePool',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'token',
                type: 'address'
              },
              {
                internalType: 'address',
                name: 'supplyTokenAddress',
                type: 'address'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'totalCompoundDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalDeposited',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalNormalBorrowed',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetScaler',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetGrowth',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'debtGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.TokenStatus',
                name: 'tokenStatus',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'baseRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'kinkRate',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope1',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'slope2',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct InterestRateModel.IRMParams',
                name: 'irmParams',
                type: 'tuple'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedProtocolRevenue',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'accumulatedCreatorRevenue',
                type: 'uint256'
              }
            ],
            internalType: 'struct DataType.AssetPoolStatus',
            name: 'underlyingPool',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'riskRatio',
                type: 'uint256'
              },
              {
                internalType: 'int24',
                name: 'rangeSize',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'rebalanceThreshold',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.AssetRiskParams',
            name: 'riskParams',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'uniswapPool',
                type: 'address'
              },
              {
                internalType: 'int24',
                name: 'tickLower',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'tickUpper',
                type: 'int24'
              },
              {
                internalType: 'uint64',
                name: 'numRebalance',
                type: 'uint64'
              },
              {
                internalType: 'uint256',
                name: 'totalAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'borrowedAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastRebalanceTotalSquartAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastFee0Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastFee1Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'borrowPremium0Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'borrowPremium1Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'fee0Growth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'fee1Growth',
                type: 'uint256'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'positionAmount',
                    type: 'int256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'lastFeeGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.UserStatus',
                name: 'rebalancePositionUnderlying',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'positionAmount',
                    type: 'int256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'lastFeeGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.UserStatus',
                name: 'rebalancePositionStable',
                type: 'tuple'
              },
              {
                internalType: 'int256',
                name: 'rebalanceFeeGrowthUnderlying',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'rebalanceFeeGrowthStable',
                type: 'int256'
              }
            ],
            internalType: 'struct Perp.SqrtPerpAssetStatus',
            name: 'sqrtAssetStatus',
            type: 'tuple'
          },
          {
            internalType: 'bool',
            name: 'isMarginZero',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isIsolatedMode',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'feeRatio',
            type: 'uint8'
          },
          {
            internalType: 'uint256',
            name: 'lastUpdateTimestamp',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.PairStatus',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256'
      }
    ],
    name: 'getPairGroup',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256'
          },
          {
            internalType: 'address',
            name: 'stableTokenAddress',
            type: 'address'
          },
          {
            internalType: 'uint8',
            name: 'marginRoundedDecimal',
            type: 'uint8'
          }
        ],
        internalType: 'struct DataType.PairGroup',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'getSqrtIndexPrice',
    outputs: [
      {
        internalType: 'uint160',
        name: '',
        type: 'uint160'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_tokenId',
        type: 'uint256'
      }
    ],
    name: 'getSqrtPrice',
    outputs: [
      {
        internalType: 'uint160',
        name: '',
        type: 'uint160'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256'
      }
    ],
    name: 'getVault',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'pairGroupId',
            type: 'uint256'
          },
          {
            internalType: 'address',
            name: 'owner',
            type: 'address'
          },
          {
            internalType: 'int256',
            name: 'margin',
            type: 'int256'
          },
          {
            internalType: 'bool',
            name: 'autoTransferDisabled',
            type: 'bool'
          },
          {
            components: [
              {
                internalType: 'uint64',
                name: 'pairId',
                type: 'uint64'
              },
              {
                internalType: 'int24',
                name: 'rebalanceLastTickLower',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'rebalanceLastTickUpper',
                type: 'int24'
              },
              {
                internalType: 'uint64',
                name: 'lastNumRebalance',
                type: 'uint64'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'amount',
                    type: 'int256'
                  },
                  {
                    internalType: 'int256',
                    name: 'entryValue',
                    type: 'int256'
                  }
                ],
                internalType: 'struct Perp.PositionStatus',
                name: 'perp',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'amount',
                    type: 'int256'
                  },
                  {
                    internalType: 'int256',
                    name: 'entryValue',
                    type: 'int256'
                  },
                  {
                    internalType: 'int256',
                    name: 'stableRebalanceEntryValue',
                    type: 'int256'
                  },
                  {
                    internalType: 'int256',
                    name: 'underlyingRebalanceEntryValue',
                    type: 'int256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'entryTradeFee0',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'entryTradeFee1',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct Perp.SqrtPositionStatus',
                name: 'sqrtPerp',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'positionAmount',
                    type: 'int256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'lastFeeGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.UserStatus',
                name: 'underlying',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'positionAmount',
                    type: 'int256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'lastFeeGrowth',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct ScaledAsset.UserStatus',
                name: 'stable',
                type: 'tuple'
              }
            ],
            internalType: 'struct Perp.UserStatus[]',
            name: 'openPositions',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Vault',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getVaultStatus',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'vaultId',
            type: 'uint256'
          },
          {
            internalType: 'int256',
            name: 'vaultValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'margin',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'positionValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'pairId',
                type: 'uint256'
              },
              {
                components: [
                  {
                    internalType: 'uint64',
                    name: 'pairId',
                    type: 'uint64'
                  },
                  {
                    internalType: 'int24',
                    name: 'rebalanceLastTickLower',
                    type: 'int24'
                  },
                  {
                    internalType: 'int24',
                    name: 'rebalanceLastTickUpper',
                    type: 'int24'
                  },
                  {
                    internalType: 'uint64',
                    name: 'lastNumRebalance',
                    type: 'uint64'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'amount',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'entryValue',
                        type: 'int256'
                      }
                    ],
                    internalType: 'struct Perp.PositionStatus',
                    name: 'perp',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'amount',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'entryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'stableRebalanceEntryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'underlyingRebalanceEntryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'entryTradeFee0',
                        type: 'uint256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'entryTradeFee1',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct Perp.SqrtPositionStatus',
                    name: 'sqrtPerp',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'positionAmount',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'lastFeeGrowth',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct ScaledAsset.UserStatus',
                    name: 'underlying',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'positionAmount',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'lastFeeGrowth',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct ScaledAsset.UserStatus',
                    name: 'stable',
                    type: 'tuple'
                  }
                ],
                internalType: 'struct Perp.UserStatus',
                name: 'position',
                type: 'tuple'
              },
              {
                internalType: 'int256',
                name: 'delta',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'unrealizedFee',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.SubVaultStatusResult[]',
            name: 'subVaults',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.VaultStatusResult',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairGroupId',
        type: 'uint256'
      }
    ],
    name: 'getVaultStatusWithAddress',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'vaultId',
            type: 'uint256'
          },
          {
            internalType: 'int256',
            name: 'vaultValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'margin',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'positionValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'pairId',
                type: 'uint256'
              },
              {
                components: [
                  {
                    internalType: 'uint64',
                    name: 'pairId',
                    type: 'uint64'
                  },
                  {
                    internalType: 'int24',
                    name: 'rebalanceLastTickLower',
                    type: 'int24'
                  },
                  {
                    internalType: 'int24',
                    name: 'rebalanceLastTickUpper',
                    type: 'int24'
                  },
                  {
                    internalType: 'uint64',
                    name: 'lastNumRebalance',
                    type: 'uint64'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'amount',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'entryValue',
                        type: 'int256'
                      }
                    ],
                    internalType: 'struct Perp.PositionStatus',
                    name: 'perp',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'amount',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'entryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'stableRebalanceEntryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'underlyingRebalanceEntryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'entryTradeFee0',
                        type: 'uint256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'entryTradeFee1',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct Perp.SqrtPositionStatus',
                    name: 'sqrtPerp',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'positionAmount',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'lastFeeGrowth',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct ScaledAsset.UserStatus',
                    name: 'underlying',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'positionAmount',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'lastFeeGrowth',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct ScaledAsset.UserStatus',
                    name: 'stable',
                    type: 'tuple'
                  }
                ],
                internalType: 'struct Perp.UserStatus',
                name: 'position',
                type: 'tuple'
              },
              {
                internalType: 'int256',
                name: 'delta',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'unrealizedFee',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.SubVaultStatusResult[]',
            name: 'subVaults',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.VaultStatusResult',
        name: '',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'vaultId',
            type: 'uint256'
          },
          {
            internalType: 'int256',
            name: 'vaultValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'margin',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'positionValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'pairId',
                type: 'uint256'
              },
              {
                components: [
                  {
                    internalType: 'uint64',
                    name: 'pairId',
                    type: 'uint64'
                  },
                  {
                    internalType: 'int24',
                    name: 'rebalanceLastTickLower',
                    type: 'int24'
                  },
                  {
                    internalType: 'int24',
                    name: 'rebalanceLastTickUpper',
                    type: 'int24'
                  },
                  {
                    internalType: 'uint64',
                    name: 'lastNumRebalance',
                    type: 'uint64'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'amount',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'entryValue',
                        type: 'int256'
                      }
                    ],
                    internalType: 'struct Perp.PositionStatus',
                    name: 'perp',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'amount',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'entryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'stableRebalanceEntryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'int256',
                        name: 'underlyingRebalanceEntryValue',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'entryTradeFee0',
                        type: 'uint256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'entryTradeFee1',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct Perp.SqrtPositionStatus',
                    name: 'sqrtPerp',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'positionAmount',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'lastFeeGrowth',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct ScaledAsset.UserStatus',
                    name: 'underlying',
                    type: 'tuple'
                  },
                  {
                    components: [
                      {
                        internalType: 'int256',
                        name: 'positionAmount',
                        type: 'int256'
                      },
                      {
                        internalType: 'uint256',
                        name: 'lastFeeGrowth',
                        type: 'uint256'
                      }
                    ],
                    internalType: 'struct ScaledAsset.UserStatus',
                    name: 'stable',
                    type: 'tuple'
                  }
                ],
                internalType: 'struct Perp.UserStatus',
                name: 'position',
                type: 'tuple'
              },
              {
                internalType: 'int256',
                name: 'delta',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'unrealizedFee',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.SubVaultStatusResult[]',
            name: 'subVaults',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.VaultStatusResult[]',
        name: '',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'globalData',
    outputs: [
      {
        internalType: 'uint256',
        name: 'pairGroupsCount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'pairsCount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'vaultCount',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'uniswapFactory',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_uniswapFactory',
        type: 'address'
      }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_closeRatio',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_sqrtSlippageTolerance',
        type: 'uint256'
      }
    ],
    name: 'liquidationCall',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'liquidator',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint64',
        name: '_pairId',
        type: 'uint64'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'tradeAmount',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'tradeAmountSqrt',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'enableCallback',
            type: 'bool'
          },
          {
            internalType: 'bytes',
            name: 'data',
            type: 'bytes'
          }
        ],
        internalType: 'struct TradePerpLogic.TradeParams',
        name: '_tradeParams',
        type: 'tuple'
      },
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_revertOnDupPair',
        type: 'bool'
      }
    ],
    name: 'openIsolatedPosition',
    outputs: [
      {
        internalType: 'uint256',
        name: 'isolatedVaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'int256',
                name: 'perpEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateUnderlying',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateStable',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'perpPayoff',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtPayoff',
                type: 'int256'
              }
            ],
            internalType: 'struct Perp.Payoff',
            name: 'payoff',
            type: 'tuple'
          },
          {
            internalType: 'int256',
            name: 'fee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TradeResult',
        name: 'tradeResult',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'operator',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      }
    ],
    name: 'reallocate',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_isolatedVaultId',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_autoTransferDisabled',
        type: 'bool'
      }
    ],
    name: 'setAutoTransfer',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newLiquidator',
        type: 'address'
      }
    ],
    name: 'setLiquidator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newOperator',
        type: 'address'
      }
    ],
    name: 'setOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isStable',
        type: 'bool'
      }
    ],
    name: 'supplyToken',
    outputs: [
      {
        internalType: 'uint256',
        name: 'finalMintAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint64',
        name: '_pairId',
        type: 'uint64'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'tradeAmount',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'tradeAmountSqrt',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'enableCallback',
            type: 'bool'
          },
          {
            internalType: 'bytes',
            name: 'data',
            type: 'bytes'
          }
        ],
        internalType: 'struct TradePerpLogic.TradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'tradePerp',
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: 'int256',
                name: 'perpEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateUnderlying',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateStable',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'perpPayoff',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtPayoff',
                type: 'int256'
              }
            ],
            internalType: 'struct Perp.Payoff',
            name: 'payoff',
            type: 'tuple'
          },
          {
            internalType: 'int256',
            name: 'fee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TradeResult',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount0',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount1',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes'
      }
    ],
    name: 'uniswapV3MintCallback',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'amount0Delta',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: 'amount1Delta',
        type: 'int256'
      },
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes'
      }
    ],
    name: 'uniswapV3SwapCallback',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'riskRatio',
            type: 'uint256'
          },
          {
            internalType: 'int24',
            name: 'rangeSize',
            type: 'int24'
          },
          {
            internalType: 'int24',
            name: 'rebalanceThreshold',
            type: 'int24'
          }
        ],
        internalType: 'struct DataType.AssetRiskParams',
        name: '_riskParams',
        type: 'tuple'
      },
      {
        internalType: 'bool',
        name: '_changeToIsolatedMode',
        type: 'bool'
      }
    ],
    name: 'updateAssetRiskParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        internalType: 'uint8',
        name: '_feeRatio',
        type: 'uint8'
      }
    ],
    name: 'updateFeeRatio',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'baseRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'kinkRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope2',
            type: 'uint256'
          }
        ],
        internalType: 'struct InterestRateModel.IRMParams',
        name: '_stableIrmParams',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'baseRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'kinkRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope2',
            type: 'uint256'
          }
        ],
        internalType: 'struct InterestRateModel.IRMParams',
        name: '_underlyingIrmParams',
        type: 'tuple'
      }
    ],
    name: 'updateIRMParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint64',
        name: '_pairGroupId',
        type: 'uint64'
      },
      {
        internalType: 'int256',
        name: '_marginAmount',
        type: 'int256'
      }
    ],
    name: 'updateMargin',
    outputs: [
      {
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint64',
        name: '_pairGroupId',
        type: 'uint64'
      },
      {
        internalType: 'uint256',
        name: '_isolatedVaultId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_marginAmount',
        type: 'int256'
      },
      {
        internalType: 'bool',
        name: '_moveFromMainVault',
        type: 'bool'
      }
    ],
    name: 'updateMarginOfIsolated',
    outputs: [
      {
        internalType: 'uint256',
        name: 'isolatedVaultId',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '_poolOwner',
        type: 'address'
      }
    ],
    name: 'updatePoolOwner',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'vaultCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isStable',
        type: 'bool'
      }
    ],
    name: 'withdrawCreatorRevenue',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isStable',
        type: 'bool'
      }
    ],
    name: 'withdrawProtocolRevenue',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pairId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isStable',
        type: 'bool'
      }
    ],
    name: 'withdrawToken',
    outputs: [
      {
        internalType: 'uint256',
        name: 'finalBurnAmount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'finalWithdrawAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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__$4278c074fd6acd31e7e5f642d169fef5d3$__9063bc9580bf9060440161072060405180830381865af4158015610742573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610766919061421f565b92915050565b60405163161f2aeb60e31b81526002600482015260248101829052600090819073__$82e740bfb21403018c74028207d6b78a82$__9063b0f95758906044016040805180830381865af41580156107c7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107eb91906142f0565b91509150915091565b6000818152600760205260408120602101546107669061081c906001600160a01b031661222a565b60008481526007602052604090206032015460ff1661229b565b61083e6122c8565b600c546001600160a01b0316331480610855575080155b61085e57600080fd5b604051635269600d60e11b81526002600482015260248101849052604481018390526064810182905273__$a1fa80d38d689cae49e54718da49b6432c$__9063a4d2c01a9060840160006040518083038186803b1580156108be57600080fd5b505af41580156108d2573d6000803e3d6000fd5b505050506108df60018055565b505050565b60006108ee6122c8565b60405163aa1e262b60e01b8152600260048201526024810185905260448101849052821515606482015273__$22e71cc2a9e9de4b2967c224ed91c7d01e$__9063aa1e262b90608401602060405180830381865af4158015610954573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610978919061431e565b905061098360018055565b9392505050565b610992612ffd565b6000828152600960205260409081902090516316c6a23f60e21b815273__$4278c074fd6acd31e7e5f642d169fef5d3$__90635b1a88fc906109de90600790600890869060040161442d565b600060405180830381865af41580156109fb573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526109839190810190614518565b60008381526007602052604090206002015483906001600160a01b03163314610a5e5760405162461bcd60e51b8152600401610671906146ef565b600084815260076020526040908190209051639fc70ca160e01b815273__$95910b7b93a5208ca27f4262a74795a535$__91639fc70ca191610aa791908790879060040161470b565b60006040518083038186803b158015610abf57600080fd5b505af4158015610ad3573d6000803e3d6000fd5b5050505050505050565b6000610ae76122c8565b604051631c3af86960e31b8152600260048201526001600160401b03861660248201526044810185905260648101849052821515608482015273__$1f4d3c4bb88e02f5b45caa05c79da92b33$__9063e1d7c3489060a401602060405180830381865af4158015610b5c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b80919061431e565b9050610b8b60018055565b949350505050565b60008281526007602052604090206002015482906001600160a01b03163314610bce5760405162461bcd60e51b8152600401610671906146ef565b6000610bda8484612321565b600d81015490915080610c145760405162461bcd60e51b815260206004820152600260248201526120ad60f11b6044820152606401610671565b6000600d8301558015610c37578154610c37906001600160a01b03163383612357565b6040805186815285151560208201529081018290527f3173529fa665e8e2fb976911ab571026d35fafa1c7327c47bb3eceeccde4c5059060600160405180910390a15050505050565b610c88613033565b610c906122c8565b6001600160401b03841660009081526007602052604090819020600101549051631e7931bf60e01b815273__$0b623280e191457df753735b6fc86de420$__90631e7931bf90610ceb906002908a908a908a90600401614770565b61010060405180830381865af4158015610d09573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d2d9190614811565b915073__$1f4d3c4bb88e02f5b45caa05c79da92b33$__63e1d7c34860028389610d5688612450565b610d5f906148b3565b6040516001600160e01b031960e087901b16815260048101949094526024840192909252604483015260648201526001608482015260a401602060405180830381865af4158015610db4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dd8919061431e565b5050610b8b60018055565b610deb613033565b610df36122c8565b604051631e7931bf60e01b815273__$0b623280e191457df753735b6fc86de420$__90631e7931bf90610e3190600290889088908890600401614770565b61010060405180830381865af4158015610e4f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109789190614811565b600b546000906001600160a01b03163314610ea05760405162461bcd60e51b815260040161067190613f33565b60405163e467935960e01b8152600260048201526001600160a01b038416602482015260ff8316604482015273__$95910b7b93a5208ca27f4262a74795a535$__9063e467935990606401602060405180830381865af4158015610f08573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610983919061431e565b6000610f366122c8565b604051636ef4d9c760e01b8152600260048201526001600160401b03841660248201526044810183905273__$1f4d3c4bb88e02f5b45caa05c79da92b33$__90636ef4d9c790606401602060405180830381865af4158015610f9c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610fc0919061431e565b905061076660018055565b61100f6040518060c00160405280600081526020016000815260200160006001600160a01b0316815260200160008152602001600015158152602001606081525090565b6000828152600960209081526040808320815160c0810183528154815260018201548185015260028201546001600160a01b03168184015260038201546060820152600482015460ff16151560808201526005820180548451818702810187019095528085529195929460a0870194939192919084015b8282101561119d5760008481526020908190206040805161010081018252600d860290920180546001600160401b038082168552600160401b8204600290810b86880152600160581b8304810b86860152600160701b909204166060808601919091528351808501855260018085015482529284015481880152608080870191909152845160c08082018752600386015482526004860154828a0152600586015482880152600686015493820193909352600785015491810191909152600884015460a0828101919091528601528351808501855260098401548152600a84015481880152908501528251808401909352600b8201548352600c909101548285015260e08301919091529083529092019101611086565b505050915250909392505050565b60008381526007602052604090206002015483906001600160a01b031633146111e65760405162461bcd60e51b8152600401610671906146ef565b600084815260076020526040908190209051631a9cd26b60e01b815273__$95910b7b93a5208ca27f4262a74795a535$__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__$95910b7b93a5208ca27f4262a74795a535$__9063dec246519060440160006040518083038186803b15801561180b57600080fd5b505af415801561181f573d6000803e3d6000fd5b505050508015611869576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b5050565b6000611877613033565b61187f6122c8565b6001600160401b0386166000908152600760205260409020600101548315806119385750336000908152600a602090815260408083208484528252918290208251808401845281548152600182018054855181860281018601909652808652611936956002959394938581019391929083018282801561191e57602002820191906000526020600020905b81548152602001906001019080831161190a575b505050505081525050896001600160401b031661251d565b155b61196f5760405162461bcd60e51b8152602060048201526008602482015267222aa82fa820a4a960c11b6044820152606401610671565b8415611a1c5773__$1f4d3c4bb88e02f5b45caa05c79da92b33$__63e1d7c3486002838b61199c8a612450565b6040516001600160e01b031960e087901b16815260048101949094526024840192909252604483015260648201526001608482015260a401602060405180830381865af41580156119f1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a15919061431e565b9250611a20565b8792505b604051631e7931bf60e01b815273__$0b623280e191457df753735b6fc86de420$__90631e7931bf90611a5e9060029087908c908c90600401614770565b61010060405180830381865af4158015611a7c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611aa09190614811565b915050611aac60018055565b9550959350505050565b60008281526007602052604090206002015482906001600160a01b03163314611af15760405162461bcd60e51b8152600401610671906146ef565b600083815260076020526040908190209051634b5f4ebf60e01b815260048101919091526001600160a01b038316602482015273__$95910b7b93a5208ca27f4262a74795a535$__90634b5f4ebf906044015b60006040518083038186803b158015611b5c57600080fd5b505af4158015611b70573d6000803e3d6000fd5b50505050505050565b336000908152600d602052604090205460ff16611b9557600080fd5b338415611c0857611c08816001600160a01b0316630dfe16816040518163ffffffff1660e01b8152600401602060405180830381865afa158015611bdd573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c01919061495f565b3387612357565b8315611c7a57611c7a816001600160a01b031663d21220a76040518163ffffffff1660e01b8152600401602060405180830381865afa158015611c4f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c73919061495f565b3386612357565b5050505050565b600080611c8c6122c8565b604051634bf8f12560e01b8152600260048201526024810186905260448101859052831515606482015273__$22e71cc2a9e9de4b2967c224ed91c7d01e$__90634bf8f125906084016040805180830381865af4158015611cf1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611d15919061497c565b91509150611d2260018055565b935093915050565b600b546000906001600160a01b03163314611d575760405162461bcd60e51b815260040161067190613f33565b6040516397bebce960e01b815273__$95910b7b93a5208ca27f4262a74795a535$__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__$95910b7b93a5208ca27f4262a74795a535$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'

type ControllerConstructorParams =
  | [linkLibraryAddresses: ControllerLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: ControllerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  )
}

export class Controller__factory extends ContractFactory {
  constructor(...args: ControllerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      const [linkLibraryAddresses, signer] = args
      super(
        _abi,
        Controller__factory.linkBytecode(linkLibraryAddresses),
        signer
      )
    }
  }

  static linkBytecode(
    linkLibraryAddresses: ControllerLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$4278c074fd6acd31e7e5f642d169fef5d3\\$__', 'g'),
      linkLibraryAddresses['src/libraries/logic/ReaderLogic.sol:ReaderLogic']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$82e740bfb21403018c74028207d6b78a82\\$__', 'g'),
      linkLibraryAddresses[
        'src/libraries/logic/ReallocationLogic.sol:ReallocationLogic'
      ]
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$a1fa80d38d689cae49e54718da49b6432c\\$__', 'g'),
      linkLibraryAddresses[
        'src/libraries/logic/LiquidationLogic.sol:LiquidationLogic'
      ]
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$22e71cc2a9e9de4b2967c224ed91c7d01e\\$__', 'g'),
      linkLibraryAddresses['src/libraries/logic/SupplyLogic.sol:SupplyLogic']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$95910b7b93a5208ca27f4262a74795a535\\$__', 'g'),
      linkLibraryAddresses['src/libraries/logic/AddPairLogic.sol:AddPairLogic']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$1f4d3c4bb88e02f5b45caa05c79da92b33\\$__', 'g'),
      linkLibraryAddresses[
        'src/libraries/logic/UpdateMarginLogic.sol:UpdateMarginLogic'
      ]
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$0b623280e191457df753735b6fc86de420\\$__', 'g'),
      linkLibraryAddresses[
        'src/libraries/logic/TradePerpLogic.sol:TradePerpLogic'
      ]
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Controller> {
    return super.deploy(overrides || {}) as Promise<Controller>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): Controller {
    return super.attach(address) as Controller
  }
  connect(signer: Signer): Controller__factory {
    return super.connect(signer) as Controller__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): ControllerInterface {
    return new utils.Interface(_abi) as ControllerInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Controller {
    return new Contract(address, _abi, signerOrProvider) as Controller
  }
}

export interface ControllerLibraryAddresses {
  ['src/libraries/logic/ReaderLogic.sol:ReaderLogic']: string
  ['src/libraries/logic/ReallocationLogic.sol:ReallocationLogic']: string
  ['src/libraries/logic/LiquidationLogic.sol:LiquidationLogic']: string
  ['src/libraries/logic/SupplyLogic.sol:SupplyLogic']: string
  ['src/libraries/logic/AddPairLogic.sol:AddPairLogic']: string
  ['src/libraries/logic/UpdateMarginLogic.sol:UpdateMarginLogic']: string
  ['src/libraries/logic/TradePerpLogic.sol:TradePerpLogic']: string
}
